import MenuItem from "@mui/material/MenuItem";
import { INGFeatureProps } from "../../library/NGFieldExtensions";
import { NavLink } from "react-router-dom";
import { getCustomLabel, getsxObject, getTestId, getURLForFeature, isNullOrEmpty } from "../../library/utils";
import { setupHandlers, setupLocalState } from "../../library/dataService";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { publishUserAction } from "../../library/analytics";
import { isEmpty } from "lodash-es";
import { useSignal } from "@preact/signals-react";
import NGIcon from "../NGIcon/NGIcon";

const MenuItemWithSubMenuAccordion = ({ config, key, handlers, handleClose }) => {
  // return config.Features.length === 0 ? (

  // ) : (

  // );
  return (
    <>
      <MenuItem id={key}>
        {config.Features.length === 0 ? (
          key
        ) : (
          <Accordion
            elevation={0}
            disableGutters
            sx={{
              backgroundColor: "transparent",
            }}
          >
            <AccordionSummary
              sx={{
                padding: 0,
                minHeight: 0,
              }}
              classes={{
                content: "custom-accordion",
              }}
            >
              <span>{config.Label}</span>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                padding: 0,
                margin: 0,
                marginTop: ".5rem",
              }}
            >
              {config.Features.map((feature, i) =>
                handlers["onClick"] ? (
                  <MenuItem
                    data-testid={getTestId(feature)}
                    color="inherit"
                    key={feature.Id}
                    onClick={(e) => {
                      console.log("onClick", e);
                      if (handlers["onClick"]) {
                        handlers["onClick"]();
                      }
                      handleClose();
                    }}
                  >
                    {feature.Label}
                  </MenuItem>
                ) : (
                  <MenuItem
                    data-testid={getTestId(feature)}
                    color="inherit"
                    key={feature.Id}
                    component={NavLink}
                    to={getURLForFeature(feature)}
                    onClick={handleClose}
                  >
                    {feature.Label}
                  </MenuItem>
                )
              )}
            </AccordionDetails>
          </Accordion>
        )}
      </MenuItem>
    </>
  );
};

export default function NGFeature({ config, context, handleClose }: INGFeatureProps) {
  const local = setupLocalState(
    config,
    {
      Visible: useSignal(config.Visible ?? true),
      StartIcon: useSignal(config.StartIcon ?? {}),
      EndIcon: useSignal(config.EndIcon ?? {}),
    },
    context
  );
  const testId = getTestId(config);
  const handlers = setupHandlers(config, context);
  // if (config.Features && config.Features.length) {
  //   return (
  //     <MenuItemWithSubMenuAccordion key={config.Id} config={config} handlers={handlers} handleClose={handleClose} />
  //   )
  // }

  if (!local.Visible.value) {
    return null;
  }

  return handlers["onClick"] || !config.AllowNavigation ? (
    <MenuItem
      data-testid={testId}
      color="inherit"
      key={config.Id}
      sx={getsxObject(config.Style)}
      onClick={(e) => {
        publishAnalytics(e);
        if (handlers["onClick"] && config.AllowNavigation) {
          handlers["onClick"]();
        }
        handleClose();
      }}
    >
      {config.Label}
    </MenuItem>
  ) : (
    <MenuItem
      data-testid={testId}
      color="inherit"
      key={config.Id}
      replace={window.location.pathname === getURLForFeature(config)}
      component={NavLink}
      sx={getsxObject(config.Style)}
      to={getURLForFeature(config)}
      onClick={(e) => {
        publishAnalytics(e);
        handleClose();
      }}
    >
      {local.StartIcon.value && !isNullOrEmpty(local.StartIcon.value.IconName) && (
        <NGIcon config={{ Style: { marginRight: "4px" }, ...local.StartIcon.value, ContextId: testId }} context={context} />
      )}
      {getCustomLabel(config.Label)}
      {local.EndIcon.value && !isNullOrEmpty(local.EndIcon.value.IconName) && (
        <NGIcon config={{ Style: { marginLeft: "4px" }, ...local.EndIcon.value, ContextId: testId }} context={context} />
      )}
    </MenuItem>
  );

  function publishAnalytics(e) {
    publishUserAction(config, context, "menu_click", e, {
      EventCategory: "navigation",
      ElementText: config.Label,
      LinkUrl: config.PageUrl ?? config.ExternalUrl,
      Outbound: !isEmpty(config.ExternalUrl)
    });
  }
}
